export default "__VITE_ASSET__CY6e3BCe__"